<template>
    <div class="content-body">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        Filtre
                    </div>
                    <div class="card-body">
                        <div class="form-group row">
                            <div class="col-sm-3">
                                <select @change="changeProduct()" v-model="query.product" class="form-control">
                                    <option value="">Tous les produits</option>
                                    <option value="1">Assurance Auto</option>
                                    <option value="3">Assurance Voyage</option>
                                    <option value="2">Assurance Habitation</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row match-height">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <save-subscription :content="subscriptions" ref="all"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SaveSubscription from "./item/saveSubscription";
    export default {
        name: "list",
        components: {SaveSubscription},
        props:['all'],
        data: () => ({
            subscriptions: {},
            step: 1,
            query:{
                namespace: 'save',
                per: 10,
                page: 1,
                product: ''
            }
        }),
        created() {
            this.subscriptions = JSON.parse(this.all);
        },
        methods:{
            changeProduct(){
                if (this.step === 1){
                    this.$refs.all.makeFilter(this.query);
                }else{
                    this.$refs.save.makeFilter(this.query);
                }
            }
        }
    }
</script>

<style scoped>

</style>
